// extracted by mini-css-extract-plugin
export default {"popupItem":"styles_popupItem__Id3Ty","item":"styles_item__xZQOd"};